import Overview from './baseOverview.vue';
import FullIndex from './full.vue';
import RoadshowIndex from './roadshow.vue';
import OfflineIndex from './offline.vue';
import ResearchIndex from './research.vue';


export const componentMap = {
    overview: Overview,
    full: FullIndex,
    roadshow: RoadshowIndex,
    offline: OfflineIndex,
    research: ResearchIndex
};
